import { Command } from 'commander';
import { ConnectContextService } from '../../services/connect-context.service.js';
import { assertEnvName, redactSecret, redactUrl } from './shared.js';

interface ShowOptions {
    json?: boolean;
}

export function createConnectShowCommand(): Command {
    return new Command('show')
        .description('Show connection detail in an environment')
        .argument('<env>', 'Environment: local|development|staging|production')
        .argument('[connection]', 'Connection name: mysql|postgres|redis|valkey')
        .option('-j, --json', 'Output JSON')
        .action(function (this: Command, envRaw: string, connectionName: string | undefined, options: ShowOptions) {
            const env = assertEnvName(envRaw);
            const context = new ConnectContextService();
            const summary = context.getEnvSummary(env);
            const useJson = !!(options.json || this.optsWithGlobals().json);
            const showSecrets = context.getSettings().redaction.showSecrets;

            if (connectionName) {
                const connection = context.getConnection(env, connectionName);
                if (!connection) {
                    throw new Error(`Connection '${connectionName}' not found in ${env}`);
                }
                if (useJson) {
                    console.log(JSON.stringify({
                        env,
                        files: summary.files,
                        connection: {
                            ...connection,
                            url: redactUrl(connection.url, showSecrets),
                            password: redactSecret(connection.password, showSecrets),
                        },
                    }, null, 2));
                    return;
                }
                console.log(`${env} (${summary.files.join(', ') || 'no env file'})`);
                console.log(JSON.stringify({
                    ...connection,
                    url: redactUrl(connection.url, showSecrets),
                    password: redactSecret(connection.password, showSecrets),
                }, null, 2));
                return;
            }

            if (useJson) {
                console.log(JSON.stringify({
                    ...summary,
                    connections: summary.connections.map((connection) => ({
                        ...connection,
                        url: redactUrl(connection.url, showSecrets),
                        password: redactSecret(connection.password, showSecrets),
                    })),
                }, null, 2));
                return;
            }

            console.log(`${env}: ${summary.files.join(', ') || 'no env file'}`);
            if (summary.connections.length === 0) {
                console.log('  no connections detected');
                return;
            }
            for (const connection of summary.connections) {
                console.log(`  - ${connection.name} (${connection.host || 'n/a'}:${connection.port || 'n/a'})`);
            }
        });
}
